import { Box } from '@mui/material'
import React, { FunctionComponent } from 'react'

export const FormActionBox: FunctionComponent = ({ children }) => (
  <Box display="flex" flexWrap="wrap" justifyContent={{ xs: 'flex-start', sm: 'flex-end' }} mt={3}>
    {children}
  </Box>
)
